import { AlertTriangle } from "lucide-react";
import type React from "react";
import { useState } from "react";
import { Button } from "./ui/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "./ui/dialog";
import { Input } from "./ui/input";

interface DeleteModalProps {
	walletName: string;
	onConfirm: () => void;
	onCancel: () => void;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
	walletName,
	onConfirm,
	onCancel,
}) => {
	const [inputValue, setInputValue] = useState("");

	const normalizeString = (str: string) =>
		str.replace(/\s+/g, "").toLowerCase();
	const isValid = normalizeString(inputValue) === normalizeString(walletName);

	const handleConfirm = () => {
		if (isValid) onConfirm();
	};

	return (
		<Dialog open onOpenChange={(o) => !o && onCancel()}>
			<DialogContent>
				<DialogHeader>
					<AlertTriangle className="mb-2 h-12 w-12 text-(--color-error-500)" />
					<DialogTitle>Delete Wallet</DialogTitle>
				</DialogHeader>
				<DialogDescription asChild>
					<div className="space-y-3">
						<p>
							This action <strong>cannot be undone</strong>. This will
							permanently delete the wallet:
						</p>
						<div className="rounded-(--radius-sm) border border-(--color-border) bg-(--color-muted) px-3 py-2 font-medium">
							{walletName}
						</div>
						<p>
							Please type <strong>{walletName}</strong> to confirm deletion:
						</p>
						<Input
							value={inputValue}
							onChange={(e) => setInputValue(e.target.value)}
							placeholder="Type wallet name here"
						/>
						{inputValue && !isValid && (
							<p className="text-(--color-error-500) text-sm">
								Wallet name does not match
							</p>
						)}
					</div>
				</DialogDescription>
				<DialogFooter>
					<Button variant="outline" onClick={onCancel}>
						Cancel
					</Button>
					<Button
						variant="destructive"
						onClick={handleConfirm}
						disabled={!isValid}
					>
						Delete Wallet
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default DeleteModal;
